var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10742 9.69287C1.77393 9.69287 0.119385 8.04492 0.119385 5.69824C0.119385 3.35156 1.77393 1.70361 4.10742 1.70361H10.0664C12.3933 1.70361 14.0544 3.35156 14.0544 5.69824C14.0544 8.04492 12.3933 9.69287 10.0664 9.69287H8.12842C7.79883 9.3501 7.77246 8.60522 8.02295 8.32837H9.9939C11.5298 8.32837 12.6174 7.24731 12.6174 5.69824C12.6174 4.15576 11.5298 3.06812 9.9939 3.06812H4.17993C2.64404 3.06812 1.5564 4.15576 1.5564 5.69824C1.5564 7.24731 2.64404 8.32837 4.17993 8.32837H4.5293C4.4502 8.73706 4.48315 9.23145 4.54248 9.69287H4.10742ZM9.43359 12.8438C7.1001 12.8438 5.44556 11.1958 5.44556 8.84912C5.44556 6.50244 7.1001 4.85449 9.43359 4.85449H11.365C11.6748 5.19727 11.7012 5.91577 11.4771 6.21899H9.5061C7.97021 6.21899 6.88257 7.30005 6.88257 8.84912C6.88257 10.3916 7.97021 11.4792 9.5061 11.4792H15.3201C16.856 11.4792 17.9436 10.3916 17.9436 8.84912C17.9436 7.30005 16.856 6.21899 15.3201 6.21899H14.9707C15.0498 5.80371 15.0234 5.31592 14.9575 4.85449H15.3926C17.7261 4.85449 19.3806 6.50244 19.3806 8.84912C19.3806 11.1958 17.7261 12.8438 15.3926 12.8438H9.43359Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.4e0311bc2346099f381bb23e849a0389.svg";
export { ForwardRef as ReactComponent };